var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSales = function SvgSales(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.29,108.06H78.43a5.93,5.93,0,0,1-5.92-5.92H31.09v23.7a11.88,11.88,0,0,0,11.85,11.85h82.9a11.88,11.88,0,0,0,11.85-11.85v-23.7H96.21A5.93,5.93,0,0,1,90.29,108.06Zm41.48-53.33H108.06a23.7,23.7,0,0,0-47.4,0H37A11.88,11.88,0,0,0,25.1,66.58V84.36A11.8,11.8,0,0,0,37,96.21H72.51V90.29a5.94,5.94,0,0,1,5.92-5.93H90.29a5.94,5.94,0,0,1,5.92,5.93v5.92h35.56a11.88,11.88,0,0,0,11.85-11.85V66.58A11.88,11.88,0,0,0,131.77,54.73Zm-59.26,0a11.85,11.85,0,0,1,23.7,0H72.51Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSales, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sales.6f91005d.svg";
export { ForwardRef as ReactComponent };